<!--
 * @Author: your name
 * @Date: 2020-09-08 19:10:20
 * @LastEditTime: 2020-09-09 20:04:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\blockRegister\editBlock.vue
-->
<template>
    <div class="editBlock">
        <van-nav-bar
            title="试块"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="handleSave"
        >
            <template #right>
                <span class="save-btn">保存</span>
            </template>
        </van-nav-bar>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                @confirm="confirmMonth"
                @cancel="showCalendar=false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 表单 -->
        <section class="van-pull-refresh">
            <van-form>
                <van-field
                    label="试验试块编号"
                    :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                    input-align="right"
                    placeholder="请输入"
                    v-model="formData.testblock_number"
                ></van-field>
                <van-field
                    label="成型日期"
                    :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    input-align="right"
                    placeholder="请选择"
                    readonly
                    clickable
                    @click="showCalendar=true"
                    v-model="formData.test_time"
                ></van-field>
                <van-field
                    label="龄期"
                    :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    class="accountAge"
                >
                    <template #input>
                        <van-radio-group v-model="formData.instar" direction="horizontal">
                            <van-radio name="7天" icon-size="16">
                                7天
                            </van-radio>
                            <van-radio name="28天" icon-size="16">
                                28天
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                    label="强度等级"
                    :left-icon="require('@/assets/images/icons/icon_gy_3.png')"
                    input-align="right"
                    v-model="formData.strength_grade_name"
                    readonly
                ></van-field>
                <van-field
                    label="实测值"
                    :left-icon="require('@/assets/images/icons/icon_2.png')"
                    input-align="right"
                    placeholder="请输入"
                    v-model="formData.measured"
                ></van-field>
                <van-field
                    label="试块尺寸"
                    :left-icon="require('@/assets/images/icons/icon_16.png')"
                    input-align="right"
                    placeholder="请输入"
                    v-model="formData.block_model"
                ></van-field>
                <van-field
                    label="委托单位"
                    :left-icon="require('@/assets/images/icons/icon_gy_8.png')"
                    input-align="right"
                    placeholder="请输入"
                    v-model="formData.entrustingparty"
                ></van-field>
                <van-field
                    label="施工部位"
                    :left-icon="require('@/assets/images/icons/icon_gy_2.png')"
                    input-align="right"
                    readonly
                    v-model="formData.place_name"
                ></van-field>

                <!-- input-align="right"
                    readonly
                    v-model="formData.project_name" -->
                <van-field
                    label="工程名称"
                    :left-icon="require('@/assets/images/icons/icon_32.png')"
                    class="project-name"
                >
                    <template #input>
                        <p>{{ formData.project_name }}</p>
                    </template>
                </van-field>
                <van-field
                    label="制作人"
                    :left-icon="require('@/assets/images/icons/icon_3.png')"
                    input-align="right"
                    readonly
                    v-model="formData.maker"
                ></van-field>
                <van-field
                    label="制作日期"
                    :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    input-align="right"
                    readonly
                    v-model="formData.make_time"
                ></van-field>
            </van-form>
        </section>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    components: {},
    props: {},
    data() {
        return {
            formData: {},
            // 日历
            showCalendar: false,
            currentDate: new Date(),
            showOverlay: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.formData = this.$route.params.data;
        const date = util.currentTimeFormat('yyyy-MM-dd');
        this.formData.maker = this.$takeTokenParameters('Name');
        this.formData.make_time = date;
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 登记时间-确认选择
        confirmMonth(value) {
            this.showCalendar = false;
            this.$nextTick(() => {
                this.formData.test_time = this.formatDate(value).split(' ')[0];
            });
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        // 保存
        handleSave() {
            this.showOverlay = true;
            this.$axios
                .post('/interfaceApi/production/formulablockpressure/modify', this.formData)
                .then(res => {
                    if (res) {
                        this.$toast('保存成功！');
                    }
                    this.showOverlay = false;
                }).catch(error => {
                    this.showOverlay = false;
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
};
</script>
<style lang="stylus">
.editBlock
    .save-btn
        color #fff
    .accountAge
        .van-cell__value
            .van-field__control
                text-align right
                justify-content flex-end
    .project-name
        .van-field__control
            p
                text-align right
                width 100%
</style>